import {
  AtsJobPostingSettingsCustomQuestionFragmentDoc,
  AtsReorderCustomQuestionsDocument,
  AtsReorderCustomQuestionsMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Variables = AtsReorderCustomQuestionsMutationVariables['questions']

export const useReorderCustomQuestions = () => {
  const [bulkUpdate, { loading, client }] = useMutation(AtsReorderCustomQuestionsDocument, {
    extractorFn: (data) => data.atsMutations.bulkUpdateAtsQuestion,
  })

  return {
    loading,
    reorder(questions: Variables) {
      return bulkUpdate({
        variables: { questions },
        optimisticResponse: {
          atsMutations: {
            bulkUpdateAtsQuestion: {
              questions: questions.flatMap((question) => {
                const cachedQuestion = client.cache.readFragment({
                  id: `AtsQuestion:${question.id}`,
                  fragment: AtsJobPostingSettingsCustomQuestionFragmentDoc,
                })

                if (!cachedQuestion) return []

                return {
                  ...cachedQuestion,
                  ...question,
                  label: question.label ?? cachedQuestion.label,
                  position: question.position ?? cachedQuestion.position,
                  mandatory: question.mandatory ?? cachedQuestion.mandatory,
                  autoDisqualify: question.autoDisqualify ?? cachedQuestion.autoDisqualify,
                  typename: 'AtsQuestion',
                }
              }),
              errors: [],
            },
          },
        },
      })
    },
  }
}
